import { service } from '@ember/service';
import Route from '@ember/routing/route';
import type ReimaginedDataService from 'tio-employee/services/reimagined-data';

export default class AuthenticatedCareerPathwaysPlanRoute extends Route {
  @service declare reimaginedData: ReimaginedDataService;

  async model() {
    const [careerPlan, dashboardData] = await Promise.all([
      this.reimaginedData.fetchCareerPlan(),
      this.reimaginedData.fetchDashboardData(),
    ]);

    return {
      careerPlan,
      employee: dashboardData.employee,
    };
  }
}
